import prod from '@/generateKey-prod'
import testnet from '@/generateKey-testnet'

const env = process.env.VUE_APP_ENV

export default (env === 'prod' ? prod : testnet)
